<script>
  let { controls, viz } = $props();

  let showMobileControls = $state(false);

  function toggleControls() {
    showMobileControls = !showMobileControls;
  }
</script>

<div class="layout-wrapper">
  <div class="control-wrapper">
    {@render controls?.(toggleControls)}
  </div>

  <div class="viz-wrapper">
    <div class="viz-inner">
      {@render viz?.()}
    </div>
  </div>
</div>

<style>
  .btn {
    display: inline-flex;
    cursor: pointer;
    justify-content: space-between;
    gap: var(--spacing-2);
    border: solid 2px var(--color-black);
    background: white;
    padding: var(--spacing-2);
  }

  .layout-wrapper {
    position: relative;
    margin-block: auto;
    max-width: 768px;
  }

  .control-wrapper {
    /* top: 0; */
    /* bottom: 0; */
    /* left: 0; */
    /* overflow-y: auto; */
    /* background: var(--color-white); */
    /* padding-right: var(--spacing-2); */
    /* width: 100%; */
    /* z-index: 500; */
    /* display: none; */
    /* max-width: 500px; */
    scrollbar-color: var(--color-gray) var(--color-white);
    flex-shrink: 0;
    flex-grow: 0;
    /* position: absolute; */
  }
  .control-wrapper::-webkit-scrollbar-thumb {
    /* Foreground */
    background: var(--color-white);
  }
  .control-wrapper::-webkit-scrollbar-track {
    /* Background */
    background: var(--color-gray-shade-lighter);
  }
  .control-wrapper.show {
    display: block;
  }
  .viz-wrapper {
    margin-inline: auto;
    max-width: 768px;
  }
  .viz-inner {
    position: sticky;
    top: 80px;
  }
  .filter-button {
    padding-bottom: var(--spacing-2);
  }

  @media (min-width: 1024px) {
    .layout-wrapper {
      display: flex;
      gap: var(--spacing-12);
      max-width: none;
    }
    .control-wrapper {
      display: block;
      padding-right: 0;
      max-width: 270px;
      position: static;
    }
    .filter-button {
      display: none;
    }
    .viz-wrapper {
      flex-grow: 1;
      padding: var(--spacing-2);
      max-width: none;
    }
  }
  .control-wrapper {
    /* width: 270px; */
  }
</style>
